import type { PreviewLayer } from '@/components/preview/preview-static-layer-renderer';

export function isPreviewLayersArray(value: unknown): value is PreviewLayer[] {
  if (!Array.isArray(value)) {
    return false;
  }
  return value.every((item) => {
    if (!item || typeof item !== 'object') {
      return false;
    }
    const o = item as Record<string, unknown>;
    return (
      typeof o.layerId === 'number' &&
      typeof o.componentId === 'string' &&
      o.position &&
      typeof o.position === 'object' &&
      typeof (o.position as { x: number }).x === 'number' &&
      typeof (o.position as { y: number }).y === 'number' &&
      typeof (o.position as { w: number }).w === 'number' &&
      typeof (o.position as { h: number }).h === 'number' &&
      (o.data === undefined || (typeof o.data === 'object' && o.data !== null))
    );
  });
}

export function isPresentationSlidesOnlyPreview(playerSyncData: Record<string, unknown> | undefined): boolean {
  if (!playerSyncData || typeof playerSyncData !== 'object') {
    return false;
  }
  const layers = playerSyncData.layers;
  if (!isPreviewLayersArray(layers) || layers.length !== 1) {
    return false;
  }
  const componentId = layers[0]?.componentId;
  return componentId === 'presentationSlides' || componentId === 'imageSequence';
}

/** Processor slide previews (presentation/PDF) use playout_1280; live playout is Full HD. */
export function isLowResolutionMediaSlidePreview(playerSyncData: Record<string, unknown> | undefined): boolean {
  if (!isPresentationSlidesOnlyPreview(playerSyncData)) {
    return false;
  }
  const fileType = (playerSyncData?.payload as { media?: { fileType?: string } } | undefined)?.media?.fileType;
  return fileType === 'presentation' || fileType === 'pdf';
}
